import React from 'react'
import HttpRequest from "../../../HttpRequest";
import {Tools} from "../../../Tools";
import Loader from "../../../components/Loader";
import ErrorPage from "../../../components/ErrorPage";
import {default as Links} from "../../../Route";
import Components from "../../../components";
import MessageBuilder from "../../../components/MessageBuilder";


const
    formFields = {
        beneficiaryId: "",
        contributionType: "",
        month: "",
        year: "",
        title: "",
        cost: "",
        startedAt: "",
        closedAt: "",
    },
    disabledAttribute = {
        disabled: "disabled",
    },
    addButtons = {
        id: "",
        set: {
            label: "Enrégistrer",
            action: "POST",
            attributes: disabledAttribute,
        }
    },
    loadingInButton = (<><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"/>Waiting...</>),
    fieldsToActiveSubmitButton = ["title", "contributionType", "cost", "startedAt"]
;

class ContributionsCreate extends React.Component{
    static contributionTypes = {
        customary_marriage : "customary_marriage",
        civil_marriage : "civil_marriage",
        customary_and_civil_marriage : "customary_and_civil_marriage",
        member_hospitalization : "member_hospitalization",
        parent_hospitalization : "parent_hospitalization",
        child_birth : "child_birth",
        death_of_a_member_parent : "death_of_a_member_parent",
        death_of_a_member : "death_of_a_member",
        annual_statutory_fee : "annual_statutory_fee",
        monthly_statutory_fee : "monthly_statutory_fee",
        membership_fees : "membership_fees"
    };
    constructor(props) {
        super(props);

        this.handleButtonClicked = this.handleButtonClicked.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.httpClient = new HttpRequest();
        this.state = {
            server: {},
            isLoadCompleted: false,
            hasPageError: false,
            hasError: false,
            contributionAdded: false,
            currentType: "",
            form: {
                fieldValues: Tools.Clone(formFields),
                fieldLabels: Tools.Clone(formFields),
                buttons: Tools.Clone(addButtons),
                currentType: ""
            }
        };
        this.formRef = React.createRef();

    }

    handleChange(field, event){
        let form = this.state.form;
        form.fieldValues[field] = event.target.value;

        // On récupère le type de la contribution, ça va permettre d'afficher les champs dans le formulaire selon la contribution sélectionnée
        if(field === "contributionType"){
            form.currentType = form.fieldValues[field];
        }

        // On definit les champs obligatoire pour le bouton "enregistrer" du formulaire ne soit pas grisé
        let fieldsRequire = Tools.Clone(fieldsToActiveSubmitButton);
        switch (this.state.form.currentType) {
            case ContributionsCreate.contributionTypes.civil_marriage:case ContributionsCreate.contributionTypes.customary_marriage:
            case ContributionsCreate.contributionTypes.child_birth:case ContributionsCreate.contributionTypes.death_of_a_member_parent:
            case ContributionsCreate.contributionTypes.death_of_a_member:case ContributionsCreate.contributionTypes.customary_and_civil_marriage:
            case ContributionsCreate.contributionTypes.member_hospitalization:case ContributionsCreate.contributionTypes.parent_hospitalization:
                    fieldsRequire.push("beneficiaryId");
                break;
            case ContributionsCreate.contributionTypes.monthly_statutory_fee:
                fieldsRequire.push("month", "year");
                break;
            case ContributionsCreate.contributionTypes.annual_statutory_fee:
                fieldsRequire.push("year");
                break;
        }

        // On compte les champs requise non vide
        let count = 0;
        fieldsRequire.forEach(function (key) {
            if(form.fieldValues[key]){
                count++;
            }
        });
        // Si le nombre de champs requise non vide correspond au nombre de champ requis, on dégrise le bouton "enrégistrer"
        form.buttons["set"].attributes = (count === fieldsRequire.length ? null : disabledAttribute);

        this.setState({form: form});
    }

    handleButtonClicked(event){
        // Here we add the loader in the button
        let form = this.state.form, newButtonLoader = Tools.Clone(addButtons);
        newButtonLoader["set"].label = loadingInButton;
        newButtonLoader["set"].attributes = disabledAttribute;
        form.buttons = newButtonLoader;
        this.setState({form: form});

        let data = {
            ...this.state.form.fieldValues,
        };

        // Call to the API
        const _self = this;
        this.httpClient.request(Links.APIPaymentsContributionsCreate, "POST", {}, data).then(function (response){
            _self.server = response;
            let state = {server: response, form: form, showAlert: true};
            if(_self.server.code === 200){
                // We reset form
                form.fieldValues = Tools.Clone(formFields);
                state = {contributionAdded: true, form: form};
            }
            form.buttons = addButtons;
            form.buttons.set.attributes = null;
            _self.setState({...state});
        }).catch(function (error){
            _self.server = error;
            form.buttons = addButtons;
            form.buttons.set.attributes = null;
            _self.setState({server: error, form: form, showAlert: true, hasAsyncError: true});
        });
    }

    handleSubmit(event){
        event.preventDefault();
    }

    render(){
        const _self = this;
        if(Tools.IsEmpty(this.beneficiaryOptions) && this.state.beneficiaries){
            this.beneficiaryOptions = this.state.beneficiaries.map((item) => {
                return <Components.Option key={"beneficiaries-" + item.id} data={{
                    value: item.id,
                    label: item.label,
                }} />
            });
        }
        if(Tools.IsEmpty(this.monthsOptions) && this.state.months){
            this.monthsOptions = this.state.months.map((item) => {
                return <Components.Option key={"months-" + item.id} data={{
                    value: item.id,
                    label: item.label,
                }} />
            });
        }
        if(Tools.IsEmpty(this.yearsOptions) && this.state.years){
            this.yearsOptions = this.state.years.map((item) => {
                return <Components.Option key={"years-" + item.id} data={{
                    value: item.id,
                    label: item.label,
                }} />
            });
        }
        if(Tools.IsEmpty(this.contributionTypesOptions) && this.state.contributionTypes){
            this.contributionTypesOptions = this.state.contributionTypes.map((item) => {
                return <Components.Option key={"contributionTypes-" + item.id} data={{
                    value: item.id,
                    label: item.label,
                }} />
            });
        }


        let fieldLabels = Tools.Clone(this.state.form.fieldLabels);
        Object.keys(fieldLabels).forEach((key) => {
            if(this.state.contribution_register_form && this.state.contribution_register_form.hasOwnProperty(key)){
                const field = this.state.contribution_register_form[key];
                fieldLabels[key] = field.label + (field.require === true && key !== "title" && key !== "contributionTypes" ? " *" : "");
            }
        });



        let element, messageElement = "";
        if(!this.state.isLoadCompleted){
            element = <Loader />;
        }
        else if(this.state.hasError){
            const text = this.state.server && this.state.server.message ? "<h1>"+ this.state.server.message +"</h1>" : "";
            element = <ErrorPage data={{content: text}} />;
        }
        else {
            if(this.state.showAlert || this.state.contributionAdded){
                let content = null,
                    messageBuilder = MessageBuilder.create(),
                    alertClass = Components.Dialogs.ALERT_TYPES.DANGER;

                if(this.state.hasAsyncError){
                    content = "Nos serveurs sont en maintenance. Revenez ultérieurement !";
                }
                else{
                    if(this.server.data && this.server.data.hasOwnProperty("fields_error")){
                        Object.keys(this.server.data.fields_error).forEach((field) => {
                            messageBuilder.addMessage(this.server.data.fields_error[field].label);
                        });
                        content = messageBuilder.getMessage();
                    }
                    if(!content && this.server.message){
                        content = this.server.message;
                    }
                    if(this.state.contributionAdded){
                        this.formRef.current.classList.add("hidden");
                        alertClass = Components.Dialogs.ALERT_TYPES.SUCCESS;
                    }
                }
                messageElement = <Components.Dialogs.AlertDialog  data={{content: content, iconClass: "", alertClass: alertClass}} />;
            }

            let subformAccordingContributionType = "";
            switch (this.state.form.currentType) {
                case ContributionsCreate.contributionTypes.civil_marriage:
                case ContributionsCreate.contributionTypes.customary_marriage:
                case ContributionsCreate.contributionTypes.child_birth:
                case ContributionsCreate.contributionTypes.death_of_a_member_parent:
                case ContributionsCreate.contributionTypes.death_of_a_member:
                case ContributionsCreate.contributionTypes.customary_and_civil_marriage:
                case ContributionsCreate.contributionTypes.member_hospitalization:
                case ContributionsCreate.contributionTypes.parent_hospitalization:
                    subformAccordingContributionType = (<div className="row">
                        <div className="col-md-6 mb-3">
                            <label htmlFor="beneficiaryId">{fieldLabels.beneficiaryId}</label>
                            <select id="beneficiaryId" name="beneficiaryId" className="form-control input-beneficiaryId input-lg" required onChange={this.handleChange.bind(this, "beneficiaryId")} value={this.state.form.fieldValues.beneficiaryId}>
                                {this.beneficiaryOptions}
                            </select>
                        </div>
                    </div>);
                    break;
                case ContributionsCreate.contributionTypes.monthly_statutory_fee:
                    subformAccordingContributionType =  (<div className="row">
                        <div className="col-md-6 mb-3">
                            <label htmlFor="month">{fieldLabels.month}</label>
                            <select id="month" name="month" className="form-control input-month input-lg" required onChange={this.handleChange.bind(this, "month")} value={this.state.form.fieldValues.month}>
                                {this.monthsOptions}
                            </select>
                        </div>
                        <div className="col-md-6 mb-3">
                            <label htmlFor="year">{fieldLabels.year}</label>
                            <select id="year" name="year" className="form-control input-year input-lg" required onChange={this.handleChange.bind(this, "year")} value={this.state.form.fieldValues.year}>
                                {this.yearsOptions}
                            </select>
                        </div>
                    </div>);
                    break;
                case ContributionsCreate.contributionTypes.annual_statutory_fee:
                    subformAccordingContributionType = (<div className="row">
                        <div className="col-md-6 mb-3">
                            <label htmlFor="year">{fieldLabels.year}</label>
                            <select id="year" name="year" className="form-control input-year input-lg" required onChange={this.handleChange.bind(this, "year")} value={this.state.form.fieldValues.year}>
                                {this.yearsOptions}
                            </select>
                        </div>
                    </div>);
                    break;
            }
            element = (
                <div className="row">
                    <div className="col-md-12">
                        {messageElement}
                        <form className="mt-6" ref={this.formRef} onSubmit={this.handleSubmit} encType="multipart/form-data">
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="contributionTypes">{fieldLabels.contributionType}</label>
                                    <select id="contributionTypes" name="contributionTypes" className="form-control input-contributionTypes input-lg" required onChange={this.handleChange.bind(this, "contributionType")} value={this.state.form.fieldValues.contributionType}>
                                        {this.contributionTypesOptions}
                                    </select>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="title">{fieldLabels.title}</label>
                                    <input id="title" className="form-control input-title input-lg" placeholder="Ex: Mariage coutumier de Harvey MOUVOULOU, Frais statutaire 2023" type="text" name="title" required onChange={this.handleChange.bind(this, "title")} value={this.state.form.fieldValues.title} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 mb-3">
                                    <label htmlFor="cost">{fieldLabels.cost}</label>
                                    <input id="cost" name="cost" className="form-control input-cost input-lg" placeholder="Ex: 650" required onChange={this.handleChange.bind(this, "cost")} value={this.state.form.fieldValues.cost} />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label htmlFor="startedAt">{fieldLabels.startedAt}</label>
                                    <input id="startedAt" name="startedAt" type="datetime-local" className="form-control input-startedAt input-lg" required onChange={this.handleChange.bind(this, "startedAt")} value={this.state.form.fieldValues.startedAt} />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label htmlFor="closedAt">{fieldLabels.closedAt}</label>
                                    <input id="closedAt" name="closedAt" type="datetime-local" className="form-control input-closedAt input-lg" onChange={this.handleChange.bind(this, "closedAt")} value={this.state.form.fieldValues.closedAt} />
                                </div>
                            </div>
                            {subformAccordingContributionType}
                            <div className="row">
                                <div className="col-md-4 mb-3">
                                    <button className="btn btn-primary btn-lg btn-block mt-6" type="submit" {...this.state.form.buttons.set.attributes} onClick={this.handleButtonClicked}
                                            data-id={this.state.form.buttons.id} data-action={this.state.form.buttons.set.action}>{this.state.form.buttons.set.label}</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            );
        }

        return element;
    }

    componentDidMount() {
        const _self = this;
        this.httpClient.request(Links.APIPaymentsContributionsFormDataCreate, "GET").then(function (response){
            _self.server = response;
            _self.setState({server: response, isLoadCompleted: true, hasError: response.code === 0, ...response.data});
        }).catch(function (error){
            _self.setState({showAlert: true, hasAsyncError: true});
        });
    }
}

export default ContributionsCreate;